import { Avatar } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function ComposerBadge(props) {
    const { locked } = props;
    const appearance = locked ? 'secondary' : 'primary';
    return (<Avatar size="md" appearance={appearance}>
      <Falcon icon="file-alt"/>
    </Avatar>);
}
